module.exports = __webpack_public_path__ + "static/sport/h504.d933be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/h504.png
// module id = O9Aa
// module chunks = 0